module.exports = __webpack_public_path__ + "img/question-diamond-fill.f6c46f43.svg";